module.exports = __webpack_public_path__ + "img/banner-vagas.16935456.jpg";